import { ButtonBS, Flex, Link, Text } from "@biblioteksentralen/react";
import { looksLikeEmail } from "@libry-content/common";
import { Event } from "@libry-content/types";
import { isNumber } from "radash";
import { ExternalLink } from "react-feather";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { Meta } from "./Meta";

type Props = Pick<Event, "registration" | "registrationUrlOrEmailOrPhone" | "digitalTicket" | "ticketInfo">;

const RegistrationButton = ({ registration, registrationUrlOrEmailOrPhone, digitalTicket, ticketInfo }: Props) => {
  const { t, ts } = useTranslation();
  if (registration === "open") return null;
  if (registration === "registration" && !registrationUrlOrEmailOrPhone) return null;
  if (registration === "ticket" && digitalTicket && !registrationUrlOrEmailOrPhone) return null;
  if (registration === "ticket" && !digitalTicket && !ts(ticketInfo)) return null;

  if (registration === "ticket" && !digitalTicket) {
    return <Meta label={t("Billetter")}>{ts(ticketInfo)}</Meta>;
  }

  if (isNumber(Number(registrationUrlOrEmailOrPhone))) {
    return (
      <Meta label={registration === "ticket" ? t("Billetter") : t("Påmelding")} alignItems="flex-start">
        <Flex flexDirection="column">
          <Text as="span" whiteSpace="nowrap">
            {t("Telefon")}
            {":"}
          </Text>
          <Link href={`tel:${registrationUrlOrEmailOrPhone}`} wordBreak="break-all">
            {registrationUrlOrEmailOrPhone}
          </Link>
        </Flex>
      </Meta>
    );
  }

  if (looksLikeEmail(registrationUrlOrEmailOrPhone)) {
    return (
      <Meta label={registration === "ticket" ? t("Billetter") : t("Påmelding")} alignItems="flex-start">
        <Flex flexDirection="column">
          <Text as="span" whiteSpace="nowrap">
            {t("Send e-post til:")}
          </Text>
          <Link href={`mailto:${registrationUrlOrEmailOrPhone}`} wordBreak="break-all">
            {registrationUrlOrEmailOrPhone}
          </Link>
        </Flex>
      </Meta>
    );
  }

  return (
    <ButtonBS as="a" href={registrationUrlOrEmailOrPhone!} variant="primary">
      {registration === "ticket" ? t("Kjøp billett") : t("Gå til påmelding")}
      <ExternalLink />
    </ButtonBS>
  );
};

export default RegistrationButton;
